<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header"><i class="icon-note"></i> Survey Detail</div>

      <template v-if="!loading">
        <b-row>
          <b-col sm="3">
            <b-form-group label-for="customer_name" label="Nama Konsumen">
              <b-form-input
                id="customer_name"
                type="text"
                v-model="listSurveyDetail.customer_name"
                readonly
                placeholder="Nama Konsumen"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group label-for="name" label="Nama Karyawan">
              <b-form-input
                id="name"
                type="text"
                v-model="listSurveyDetail.employee_name"
                readonly
                placeholder="Nama Karyawan"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group label-for="date_survey" label="Tanggal Survey">
              <b-form-input
                id="date_survey"
                type="text"
                v-model="listSurveyDetail.date_survey"
                readonly
                placeholder="Tanggal Survey"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="6">
            <b-form-group label-for="name" label="Lokasi Survey">
              <GmapMap
                v-if="myLocation != null"
                :center="myLocation"
                :zoom="10"
                map-type-id="terrain"
                style="height: 500px"
              >
                <GmapMarker :key="0" :title="'asd'" :position="myLocation">
                  <GmapInfoWindow
                    :options="{ maxWidth: 300 }"
                    :position="myLocation"
                    :opened="true"
                  >
                    <div>My Location</div>
                  </GmapInfoWindow>
                </GmapMarker>

                <GmapMarker :key="1" :title="'asd'" :position="locationToko">
                  <GmapInfoWindow
                    :options="{ maxWidth: 300 }"
                    :position="locationToko"
                    :opened="true"
                  >
                    <div>{{ listSurveyDetail.customer_name }}</div>
                  </GmapInfoWindow>
                </GmapMarker>
              </GmapMap>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4">
            <b-form-group label-for="name" label="Gambar 1">
              <b-img
                :src="urlAssets + listSurveyDetail.picture1"
                :thumbnail="true"
              ></b-img>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label-for="name" label="Gambar 2">
              <b-img
                :src="urlAssets + listSurveyDetail.picture2"
                :thumbnail="true"
              ></b-img>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label-for="name" label="Gambar 3">
              <b-img
                :src="urlAssets + listSurveyDetail.picture3"
                :thumbnail="true"
              ></b-img>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="12">
            <div class="text-right">
              <b-button type="button" size="sm" variant="danger" @click="back">
                <i class="fa fa-undo"></i> Back </b-button
              >&nbsp;
            </div>
          </b-col>
        </b-row>
      </template>

      <template v-else>
        <b-row>
          <b-col>
            <loading></loading>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../../templates/Table.vue";
import { gmapApi } from "vue2-google-maps";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_detail",
  components: { globalTable, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      urlAssets: "https://storage.googleapis.com/mbsstorage/",
      google: gmapApi,
      locationToko: null,
      myLocation: null,
      listSurveyDetail: [],
      loading: true,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function (survey_id) {
      this.loading = true;
      this.getAllSurveyDetail(survey_id);
    },
    getAllSurveyDetail: function (survey_id) {
      this.axios
        .get("web/survey/detail-freezer/" + survey_id)
        .then((response) => {
          this.listSurveyDetail = response.data.data;
          this.myLocation = {
            lat: this.listSurveyDetail.lat,
            lng: this.listSurveyDetail.lng,
          };
          this.locationToko = {
            lat: this.listSurveyDetail.lat_toko_asal,
            lng: this.listSurveyDetail.lng_toko_asal,
          };
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Ubah Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[5]);
  },
};
</script>